module.exports = __webpack_public_path__ + "static/media/share.4dfc2817.svg";